import React, { lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import DoctorOnboarding from "./components/auth/DoctorOnboarding";
import MarketingLayout from "./components/marketing/MarketingLayout";

// Lazy load marketing components
const Login = lazy(() => import("../src/components/auth/Login"));
const Wishlist = lazy(() => import("../src/components/marketing/Wishlist"));
const Orders = lazy(() => import("../src/components/marketing/Orders"));
const Cart = lazy(() => import("../src/components/marketing/Cart"));
const Marketing = lazy(() => import("../src/components/marketing/Marketing"));
const Products = lazy(() =>
  import("../src/components/marketing/ProductDetails")
);

function MarketingRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<MarketingLayout />}>
          <Route path="/" element={<Marketing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/product" element={<Products />} />
          <Route path="/onboarding" element={<DoctorOnboarding />} />
        </Route>
      </Routes>
    </>
  );
}

export default MarketingRoutes;
